import React from 'react';
import { uuid } from 'uuidv4';

import '../App.css';

import LandingGamePreview from './LandingGamePreview';

class LandingPage extends React.Component
{
	renderGallery = (gameList) =>
	{
		var divs = [];

		for (var i = 0; i < gameList.length; i++)
		{
			divs.push(
				<LandingGamePreview
					key={uuid()}
					game={gameList[i]}
				/>
			);
		}

		return (
			<React.Fragment>
				{divs}
			</React.Fragment>
		);
	}

	render()
	{
		return (

			<div className='page landing-page'>
				
				<div className='landing-splash-section'>

					<div className='landing-black-overlay'>

						<div className='landing-info-container'>

							<img className='landing-info-logo' src={require('../images/logo/logo.png')}/>

							<p className='landing-info-name'>TUP LUISKING</p>
							<p className='landing-info-role'>GAME DEVELOPER</p>

						</div>

					</div>

				</div>

				<div className='section landing-games-section'>

					<p className='section-header'>
						Games
					</p>

					<div className='landing-games-details'>

						Click <a
							href="/games"
							className='landing-games-details-link'>
							HERE
						</a> for a more detailed list of my games.

					</div>

					<div className='landing-games-gallery'>

						{ this.renderGallery(this.props.gameList) }

					</div>

				</div>
			</div>

		);
	}
}

export default LandingPage;